import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import HospitalShowcase from "@/components/HospitalShowcase";
import CompleteHospitalSetup from "@/components/CompleteHospitalSetup";
import WhyChooseUs from "@/components/WhyChooseUs";
import Founder from "@/components/Founder";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { Toaster } from "@/components/ui/sonner";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";
import FAQ from "@/pages/FAQ";
import LoanTypes from "@/pages/LoanTypes";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <About />
      <Services />
      <HospitalShowcase />
      <CompleteHospitalSetup />
      <WhyChooseUs />
      <Founder />
      <Contact />
      <Footer />
      <WhatsAppButton />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/loan-types" element={<LoanTypes />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
